import { withStyles } from '@material-ui/core/styles';
import { createStyles, TableRow, Theme } from '@material-ui/core';

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#04153A', // Default to dark blue (even rows 2, 4, 6...) which correspond to odd indices if we consider 1-based nth-of-type?
      // Actually nth-of-type(odd) is 1, 3, 5.
      // We want 1st row (index 0) to be #071B4A. So odd -> #071B4A.
      '&:nth-of-type(odd)': {
        backgroundColor: '#071B4A',
      },
      '&:nth-of-type(even)': {
        backgroundColor: '#04153A',
      },
      '& td': {
        borderBottom: 'none',
        color: '#FFFFFF',
      },
    },
  })
)(TableRow);

export default StyledTableRow;
